// extracted by mini-css-extract-plugin
export default {"section-heading-holder":"CollectionTwo_section-heading-holder__jNOEF","collection-two-holder":"CollectionTwo_collection-two-holder__+dYxy"};